// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"23":"agenda","177":"home","914":"publishers","963":"event"}[chunkId] + "." + {"23":"f336c9dd","177":"58471fd1","914":"a70ce82f","963":"1b05c3a9"}[chunkId] + ".js";
};